import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Tailwind's prefix must be the FIRST segment of a candidate (`tw:hover:x`,
// not `hover:tw:x`) — the latter silently compiles to nothing.
const VARIANT_CLASSES = {
	default:
		'tw:bg-surface tw:text-ink-0 tw:border-border-strong tw:hover:bg-surface-2 tw:hover:border-ink-3',
	primary: 'tw:bg-accent tw:text-white tw:border-accent tw:hover:bg-accent-hover tw:hover:border-accent-hover',
	ghost: 'tw:bg-transparent tw:text-ink-0 tw:border-transparent tw:hover:bg-surface-3',
};

const SIZE_CLASSES = {
	default: 'tw:h-[34px] tw:px-3.5 tw:text-[13px]',
	sm: 'tw:h-7 tw:px-2.5 tw:text-[12.5px]',
};

/**
 * `.btn` from the entity-list spec. Exactly one `variant="primary"` per page.
 */
function Button({ variant = 'default', size = 'default', icon, className, children, ...rest }) {
	return (
		<button
			type='button'
			className={classnames(
				'tw:inline-flex tw:items-center tw:gap-[7px] tw:rounded-[7px] tw:font-medium tw:border tw:transition-[background,border-color] tw:duration-100',
				VARIANT_CLASSES[variant],
				SIZE_CLASSES[size],
				className,
			)}
			{...rest}
		>
			{icon && <span className='tw:text-[14px] tw:leading-none tw:flex'>{icon}</span>}
			{children}
		</button>
	);
}

Button.propTypes = {
	variant: PropTypes.oneOf(['default', 'primary', 'ghost']),
	size: PropTypes.oneOf(['default', 'sm']),
	icon: PropTypes.node,
	className: PropTypes.string,
	children: PropTypes.node,
};

export default Button;
